import { render, staticRenderFns } from "./ApiImage.vue?vue&type=template&id=33bbc3c0&scoped=true&"
import script from "./ApiImage.vue?vue&type=script&lang=js&"
export * from "./ApiImage.vue?vue&type=script&lang=js&"
import style0 from "./ApiImage.vue?vue&type=style&index=0&id=33bbc3c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bbc3c0",
  null
  
)

export default component.exports